import { useState } from "react";
import { Link } from "react-router-dom";
import { dailyPosts } from "@/mocks/dailyPosts";

const CATEGORIES = ["全部", ...Array.from(new Set(dailyPosts.map((p) => p.category)))];

export default function DailyFeed() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? dailyPosts : dailyPosts.filter((p) => p.category === active);

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="text-xs font-medium tracking-[0.3em] text-primary-600">SECT DAILY</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            师门日常
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
            抢灵果、炸丹炉、偷跑下山……云隐峰的日常，吵吵闹闹里全是剪不断的同门情谊。
          </p>
        </div>
        <Link
          to="/daily"
          className="whitespace-nowrap rounded-md border border-primary-200 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-50"
        >
          全部师门日常
        </Link>
      </div>

      <div className="mt-8 flex flex-wrap gap-2" role="tablist" aria-label="师门日常分类筛选">
        {CATEGORIES.map((c) => {
          const activeTab = active === c;
          return (
            <button
              key={c}
              type="button"
              role="tab"
              aria-selected={activeTab}
              onClick={() => setActive(c)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                activeTab
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {c}
            </button>
          );
        })}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((post) => (
          <article
            key={post.id}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <Link to="/daily" className="block">
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={post.cover}
                  alt={`${post.title} 师门日常插画`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-3 py-1 text-xs text-accent-200 backdrop-blur">
                  {post.category}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line" />
                  <span>更新于 {post.date}</span>
                </div>
                <h3 className="mt-2 font-heading text-lg leading-6 text-foreground-950 group-hover:text-primary-700">
                  {post.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{post.excerpt}</p>
              </div>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}